import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EVENT_STATUS, EVENT_STATUS_VALUES, PAGES } from '../../constants';

const TABLE_HEADERS = ['Round ID', 'Date', 'Status', 'Round Number', 'Season Id', 'Corners Count', 'Goals', 'League',];

function getFormattedDateAndTime(eventDateString, timezone) {
  // Expecting eventDateString in "YYYY-MM-DD HH:mm:ss" format
  if (!eventDateString) return { date: '', time: '' };

  // Parse as UTC and convert to user's timezone
  const utcDate = new Date(`${eventDateString.replace(' ', 'T')}Z`);
  const localString = utcDate.toLocaleString('en-GB', { timeZone: timezone, hour12: false });

  // localString: "dd/mm/yyyy, HH:MM:SS"
  const [date, time] = localString.split(', ');
  const [day, month] = date.split('/');
  const [hour, minute] = time.split(':');

  return {
    date: `${day}/${month}`,
    time: `${hour}:${minute}`,
  };
}

function formatTimeHeadersWithTimezone(hour, timezone) {
  const hourInt = parseInt(hour, 10);
  const date = new Date();
  date.setHours(hourInt);
  const dateWithTimezone = date.toLocaleString('en-GB', { timeZone: timezone });
  // eslint-disable-next-line no-unused-vars
  const [_, time] = dateWithTimezone.split(', ');
  const [hourWithTimezone] = time.split(':');
  return `${hourWithTimezone}:00`;
}

const RoundSpecialsTable = ({
  rounds, leagues, timezone
}) => {
  const [openedMenu, setOpenedMenu] = useState('');
  
  function openContextMenu(matchId, event) {
    event.preventDefault();
    const newValue = matchId === openedMenu ? '' : matchId;
    setOpenedMenu(newValue);
  }
  
  function closeContextMenu() {
    setOpenedMenu('');
  }

  return (
    <table className="table-style table-style--event">
      <thead>
        <tr>
          {TABLE_HEADERS.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
          <th className="menu" />
        </tr>
      </thead>
      <tbody>
        {rounds.map((data, index) => (
          <React.Fragment key={index}>
            {index < rounds.length - 1 && index > 0 && (
              <tr key={data.hour} className="table-style__row table-style__row--time black ">
                <td className="text-left p-l-20" colSpan="8">
                  {formatTimeHeadersWithTimezone(data.hour, timezone)}
                </td>
              </tr>
            )}
            {
              data.rounds.map((round) => {
                const formattedDateAndTime = getFormattedDateAndTime(round.startDateTime, timezone);
        
                return (
                  <tr
                    key={round.roundId}
                    className={`table-style__row status--${round.isSkipped ? 'skipped' : EVENT_STATUS[round.statusId]} 
                          ${round.bookedFlag ? 'table-style__row--booked' : ''} ${openedMenu === round.roundId ? 'open' : ''}`}
                    onContextMenu={openContextMenu.bind(null, round.roundId)}>
                    <td>{round.roundId}</td>
                    <td>
                      {formattedDateAndTime.date}
                      {' '}
                      <span className="m-l-10">{formattedDateAndTime.time}</span>
                    </td>
                    <td className="status" />
                    <td>{round.roundPublicId}</td>
                    <td>{round.seasonId}</td>
                    <td>{round.roundTotalCorners}</td>
                    <td>{round.roundTotalScore}</td>
                    <td>{leagues.find((l) => l.id === round.leagueId)?.name}</td>
                    <td>
                      <div className="context-menu">
                        <div className="context-menu__list">
                          <Link
                            to={`${PAGES.ROUND_SPECIALS_ODDS_HISTORY_STEP_1}/${round.roundId}`}
                          >
                            <div className="context-menu__list-item">
                                Odds History
                            </div>
                          </Link>
                          {round.statusId === EVENT_STATUS_VALUES.ENDED || round.statusId === EVENT_STATUS_VALUES.IN_PROGRESS ? <Link
                            to={`${PAGES.ROUND_SPECIALS_MATCH_TIMELINE}/${round.roundId}`}
                          >
                            <div className="context-menu__list-item">
                                Round timeline
                            </div>
                          </Link> : null}
                        </div>
                        <div className="context-menu__mask" onClick={closeContextMenu} />
                      </div>
                    </td>
                  </tr>
                );
              })
            }
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
};

export default RoundSpecialsTable;;